// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { FieldsFactory } from "../Factory/FieldsFactory.js"
import { MessageProcessorBase } from "./MessageProcessorBase.ts"
import { DirectInstrumentTypeMessage } from "../../../../Utils/DirectMessages/DirectInstrumentTypeMessage.js"
import { AliasesGroup } from "../Groups/GroupsImport.js"
export let InstrumentTypeMessageProcessor = function ()
{
    MessageProcessorBase.call(this)
}

InstrumentTypeMessageProcessor.prototype = Object.create(MessageProcessorBase.prototype)

InstrumentTypeMessageProcessor.prototype.decode = function (fs)
{
    let message = new DirectInstrumentTypeMessage()
    let ff = FieldsFactory

    message.TypeName = fs.GetValue(ff.FIELD_NAME)
    message.TypeId = fs.GetValue(ff.FIELD_INSTRUMENTTYPE_ID)
    message.SuperTypeId = fs.GetValue(ff.FIELD_SUPER_ID)
    message.LanguageAliases = AliasesGroup.GetFromFieldSet(fs, true)
    message.MinimalLot = fs.GetValue(ff.FIELD_MINIMAL_LOT);
    message.MaximalLot = fs.GetValue(ff.FIELD_MAX_LOT);

    let extendedFieldsGroup = fs.GetGroups(ff.KEY_VALUE_GROUP);
    for (let i = 0; i < extendedFieldsGroup.length; i++)
    {
        let field = extendedFieldsGroup[i]
        message.ExtendedFields[field.GetValue(ff.FIELD_KEY)] = field.GetValue(ff.FIELD_VALUE);
    }


    return [message]
}
